import { render } from "./general_popup.vue?vue&type=template&id=60365f3e&scoped=true"
import script from "./general_popup.vue?vue&type=script&lang=js"
export * from "./general_popup.vue?vue&type=script&lang=js"

import "./general_popup.vue?vue&type=style&index=0&id=60365f3e&scoped=true&lang=css"

import exportComponent from "/Users/danramage/Documents/workspace/WaterQuality/RiverWQApp_Vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60365f3e"]])

export default __exports__